import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { TeamsRankingQuery } from '../types';

/**
 * typeguard for TeamsRankingQuery
 * @param TeamsRankingQuery object passed to transformer
 */
export const isValidTeamsRanking = (obj: TeamsRankingQuery): boolean => Boolean(obj?.data?.getTeamRankingWidget && !isEmptyObject(obj.data.getTeamRankingWidget) );
